import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { AuthLayout } from "@/pages/Login";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, ROLE_LABEL } from "@/lib/api";

export default function AcceptInvite() {
  const { token } = useParams();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [f, setF] = useState({ name: "", password: "", confirm: "", phone: "" });

  useEffect(() => {
    api.get(`/auth/invite/${token}`).then((r) => { setInfo(r.data); setF((x) => ({ ...x, name: r.data.name })); }).catch((e) => setError(errMsg(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (f.password !== f.confirm) return setError("Passwords do not match");
    setError("");
    try {
      await api.post("/auth/invite/accept", { token, name: f.name, password: f.password, phone: f.phone || null });
      const { data } = await api.get("/auth/me");
      setUser(data); navigate("/");
    } catch (err) { setError(errMsg(err)); }
  };

  if (!info) return <AuthLayout title="Accept invitation">{error ? <p className="rounded-md bg-red-50 p-3 text-sm text-red-700" data-testid="invite-error">{error}</p> : <p className="text-sm text-muted-foreground">Checking invitation…</p>}</AuthLayout>;
  return (
    <AuthLayout title="Accept invitation" subtitle={`${info.email} · ${ROLE_LABEL[info.role]}${info.company_name ? ` at ${info.company_name}` : ""}`}>
      <form onSubmit={submit} className="space-y-4" data-testid="accept-invite-form">
        <Field label="Full name"><Input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="accept-name-input" /></Field>
        <Field label="WhatsApp number (for reminders)"><Input placeholder="+255…" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="accept-phone-input" /></Field>
        <Field label="Password (min 8 characters)"><Input type="password" required minLength={8} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="accept-password-input" /></Field>
        <Field label="Confirm password"><Input type="password" required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="accept-confirm-input" /></Field>
        {error && <p className="rounded-md bg-red-50 p-3 text-sm text-red-700" data-testid="invite-error">{error}</p>}
        <Button type="submit" className="w-full" data-testid="accept-submit-btn">Activate account</Button>
      </form>
    </AuthLayout>
  );
}
